import React from "react";
import PropTypes from "prop-types";
import {useIntl} from "react-intl";
import {useHistory} from "react-router-dom";

import {Box, TableCell, TableRow} from "@mui/material";

import TopProductCell from "../../TopTablesComponents/TopProductCell";

import {
    black500,
    greyishBlue600,
    orange600,
    red500
} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

function RetailerRow({ rank, retailer, currency }) {
    const intl = useIntl();
    const history = useHistory();

    const {
        id,
        name,
        sales = 0,
        potentialRevenue = 0,
        actualRevenue = 0,
        returnRevenue = 0,
        returnRate = 0,
        storeCancellation = 0,
        storeCancellationRate = 0,
        clientCancellation = 0,
        clientCancellationRate = 0,
        topProducts = [],
    } = retailer ?? {};

    const formatCurrency = (value) => intl.formatNumber(value, { style: "currency", currency: currency ?? "EUR" });

    return (
        <TableRow hover
            sx={{
                cursor: 'pointer',
                "td" : {padding: '20px 10px'},
                "td:last-of-type": { paddingRight: '20px' },
                "td:first-of-type": { paddingLeft: '20px' },
            }}
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_SHOW(id), history)}
        >

            <TableCell sx={{ fontSize: "14px", color: black500,  }}>
                <Box sx={{display: "flex", alignItems: "baseline", gap: "4px"}}>
                    <div style={{
                        fontWeight: 600,
                        color: greyishBlue600,
                        fontSize: "14px",
                        width: "20px",
                        textAlign: "center",
                        flexShrink: 0
                    }}>
                        {rank}
                    </div>
                    {name}
                </Box>
            </TableCell>

            <TableCell align="left" sx={{ fontSize: "14px", fontWeight: 600, color: black500 }}>
                {sales.toLocaleString()}
            </TableCell>

            <TableCell>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: "4px" }}>
                    {topProducts.map((p, i) => (
                        <TopProductCell
                            id={p.id}
                            sku={p.sku}
                            image={p.image}
                            sales={p.sales}
                            key={i}
                            retailerId={id}
                            bottomContent={(
                                <b>{Number(p.sales).toLocaleString()} {intl.formatMessage({ id: "dashboard.retailersRanking.topProduct.sales" })}</b>
                            )}
                        />
                    ))}
                </Box>
            </TableCell>

            <TableCell align="left" sx={{ fontSize: "14px", color: greyishBlue600 }}>
                {formatCurrency(potentialRevenue)}
            </TableCell>

            <TableCell align="left" sx={{ fontSize: "14px", color: black500 }}>
                <b>{formatCurrency(actualRevenue)}</b>
            </TableCell>

            <TableCell align="left" sx={{ color: orange600 }}>
                <div style={{ fontSize: "14px" }}>{formatCurrency(returnRevenue)}</div>
                <div style={{ fontSize: "12px" }}>({returnRate}%)</div>
            </TableCell>

            <TableCell align="left" sx={{ color: red500 }}>
                <div style={{ fontSize: "14px" }}>{formatCurrency(storeCancellation)}</div>
                <div style={{ fontSize: "12px" }}>({storeCancellationRate}%)</div>
            </TableCell>

            <TableCell align="left" sx={{ color: red500 }}>
                <div style={{ fontSize: "14px" }}>{formatCurrency(clientCancellation)}</div>
                <div style={{ fontSize: "12px" }}>({clientCancellationRate}%)</div>
            </TableCell>
        </TableRow>
    );
}

RetailerRow.propTypes = {
    rank: PropTypes.number.isRequired,
    retailer: PropTypes.shape({
        name: PropTypes.string,
        sales: PropTypes.number,
        potentialRevenue: PropTypes.number,
        actualRevenue: PropTypes.number,
        returnRevenue: PropTypes.number,
        returnRate: PropTypes.number,
        storeCancellation: PropTypes.number,
        storeCancellationRate: PropTypes.number,
        clientCancellation: PropTypes.number,
        clientCancellationRate: PropTypes.number,
        topProducts: PropTypes.arrayOf(PropTypes.shape({
            sku: PropTypes.string,
            image: PropTypes.string,
            sales: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })),
    }),
    currency: PropTypes.string,
};

export default RetailerRow;
